import { useTheme } from "@hooks";
import { constants, spacing } from "@layout";
import { CSSProperties } from "react";

export const useStyles = () => {
  const { theme } = useTheme();

  const styles: Record<string, CSSProperties> = {
    container: {
      backgroundColor: theme.card.background,
      padding: constants.divPadding,
      paddingRight: constants.divPadding,
      paddingTop: spacing.m,
      paddingBottom: spacing.m,
      borderRadius: constants.radius.view,
      userSelect: "none",
      cursor: "pointer",
    },
    text: {
      marginRight: spacing.xxs,
    },
    goals: {
      backgroundColor: theme.accounts.item.goal.background,
      color: theme.accounts.item.goal.text,
      display: "inline",
      flexShrink: 0,
      paddingLeft: spacing.xs,
      paddingRight: spacing.xs,
      paddingTop: spacing.xxs,
      paddingBottom: spacing.xxs,
      borderRadius: constants.radius.button,
      fontSize: 12,
    },
    amount: {
      fontSize: 12,
      fontWeight: 500,
    },
    current: {
      color: theme.accounts.item.amount.current,
    },
    projected: {
      color: theme.accounts.item.amount.projected,
    },
  };

  return styles;
};
